import { useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  getLocalStorageItem,
  removeLocalStorageItem,
  setLocalStorageItem,
} from "../utils/localStorageUtil";

const RETURN_ROUTE_KEY = "demandStudioReturnRoute";
const FALLBACK_ROUTE = "/";

// remembers where the user came from so Demand Studio can return there on close
const useDemandStudioReturnRoute = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const saveReturnRoute = useCallback(() => {
    setLocalStorageItem(RETURN_ROUTE_KEY, `${location.pathname}${location.search}`);
  }, [location.pathname, location.search]);

  const returnToPreviousRoute = useCallback(() => {
    const previousRoute = getLocalStorageItem(RETURN_ROUTE_KEY);
    removeLocalStorageItem(RETURN_ROUTE_KEY);
    navigate(previousRoute || FALLBACK_ROUTE);
  }, [navigate]);

  return { saveReturnRoute, returnToPreviousRoute };
};

export default useDemandStudioReturnRoute;
